export default __webpack_public_path__ + "static/media/neolithic_illustration.c1787f0f.png";